import { render, staticRenderFns } from "./TabletInfos.vue?vue&type=template&id=62bdc207&"
import script from "./TabletInfos.vue?vue&type=script&lang=js&"
export * from "./TabletInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports